import { render, staticRenderFns } from "./ShopsInfo.vue?vue&type=template&id=007c3692&"
import script from "./ShopsInfo.vue?vue&type=script&lang=js&"
export * from "./ShopsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports